import { Grid } from "@material-ui/core";
import { DialogContent, Typography } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import DeleteDialogBox from "../../components/DialogBoxComponent/DeleteDialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import { deleteDevice } from "../../slices/Zlink Device Management/DeviceSlice";
import { ThemeContext } from '../../theme/ThemeContext';

export default function DeleteDevice(props) {
  const { open, onClose, reloadlist, deleteData } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);
  const [payload, setPayload] = React.useState({
    id: deleteData.id,
    deviceName: deleteData.deviceName,
  });

  const handleSubmit = (data) => {

    dispatch(deleteDevice(payload.id))
      .unwrap()
      .then((data) => {
        if (data.code === "DMSI0000") {
          Toast("Device Deleted successfully.", 'success');
          onClose();
          reloadlist();
        }
        else {
          Toast((data.message), 'error')
          onClose();
        }
      })
  }

  return (
    <div>
      <DeleteDialogBox
        Header={
          <span style={{ fontSize: "21px", color: darkMode ? "#fff" : "" }}>
            {t("COMMON004")}
          </span>
        }
        acceptText={t("CONFIRM")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        onClose={onClose}
        cancel={onClose}
        onSubmit={handleSubmit}
        open={open}
      >
        <DialogContent sx={{ textAlign: "center" }}>
          <Grid
            p={2}
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: "10px",
            }}
          >
            <Typography
              style={{
                color: darkMode ? "#D5D5D5" : "#474A4E",
                marginRight: "4px",
                fontFamily: "font_medium",
                opacity: 0.8,
              }}
            >
              {'Are you sure you want to delete this device for '} {`'${payload.deviceName}'`}?
            </Typography>
          </Grid>
        </DialogContent>
      </DeleteDialogBox>
    </div>
  );
}
